import React from 'react';
import '../index.css';

const Nav = () => {
    const toggleMenu = () => {
        const navLinks = document.querySelector('.nav-links');
        navLinks.classList.toggle('show');
        document.body.classList.toggle('nav-open');
        document.querySelector('.logo-item').style.display = navLinks.classList.contains('show') ? 'none' : 'flex';
    };

    return (
        <nav>
            <div className="nav-left">
                <a href="/" className="nav-logo"><img src="https://media.productionrp.org/website/images/prplogo-160x160.webp" className="nav-image" alt="ProductionRP logo, home" loading="lazy" /></a>
                <div className="menu-icon" onClick={toggleMenu}>&#9776;</div>
            </div>
                <ul className="nav-links">
                    <li><a href="https://store.productionrp.org/">STORE</a></li>
                    <li><a href="https://core.productionrp.org/">CORE</a></li>
                    <li className="logo-item"><a href="/"><img src="https://media.productionrp.org/website/images/prplogo-160x160.webp" className="nav-image" alt="ProductionRP logo, home" loading="lazy" /></a></li>
                    <li><a href="https://doj.productionrp.org/">DOJ</a></li>
                    <li><a href="fivem://connect/play.productionrp.org">CONNECT</a></li>
                </ul>
        </nav>
    );
};

export default Nav;
